export default __webpack_public_path__ + "static/media/completed-check.9cbfc104.svg";